import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';
import {WizardInterfaces} from '../../../../wizard.namespace';

@Injectable()
export class EquipmentApiService extends ApiService {
    baseUrl = 'group/wizard-list';

    getGroups(
        attestation: WizardInterfaces.AttestationValue,
        methodId: number,
        reference: boolean = false
    ) {
        return this.post<WizardListRequest, WizardInterfaces.ApparatusStepGroup[]>({
            /**
             * queryParams тут исключительно для удобной навигации в запросах в консоли
             */
            queryParams: {
                method_id: methodId,
                reference
            },
            dataBody: {
                is_reference: reference,
                method_id: methodId,
                object_ids: attestation.objects.map(o => +o.id),
                submethods_ids: attestation.submethods.map(s => +s.id),
            }
        }).pipe();
    }
}

/**
 * Интерфейс запроса групп оборудования
 */
interface WizardListRequest {
    /**
     * Является ли образцом и эталоном (true) или же это основное оборудование (false)
     */
    is_reference: boolean;

    /**
     * id метода, для которого запрашиваются группы
     */
    method_id: number;

    /**
     * Ids выбранных объектов области аттестации для текущего метода
     */
    object_ids: number[];

    /**
     * Ids выбранных подметодов для текущего метода
     */
    submethods_ids: number[];
}
